"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBackgroundUploadedOnStageSLI = void 0;
var _react = require("react");
var _commonWebAnalytics = require("@studio/metrics/client/web/commonWebAnalytics");
/**
 * Custom hook to manage the state of background uploads to the stage.
 *
 * @returns {Object} An object containing the following properties:
 * - startBackgroundUploadedOnStageSLI: Function to start the background upload on stage.
 */
var useBackgroundUploadedOnStageSLI = exports.useBackgroundUploadedOnStageSLI = function useBackgroundUploadedOnStageSLI() {
  var startBackgroundUploadedOnStageSLI = (0, _react.useCallback)(function (fileSizeInBytes) {
    // ending an orphaned measurement, nothing happens if none are active
    _commonWebAnalytics.commonWebAnalytics.endStudioBackgroundUploadedOnStage({
      result: 'incomplete_measure',
      type: 'handled_error',
      error_message: 'User initiated the new background upload before the previous background upload was completed'
    });
    _commonWebAnalytics.commonWebAnalytics.startStudioBackgroundUploadedOnStage({
      fileSizeInBytes: fileSizeInBytes
    });
  });
  return {
    startBackgroundUploadedOnStageSLI: startBackgroundUploadedOnStageSLI
  };
};